module.exports = __webpack_public_path__ + "static/media/bingo-active.b5d91546.png";